import { Icon } from "@chakra-ui/react"
import { PtBtn } from "../../../componentsF/Chakra3F/ChakraF.jsx"
import { VscRobot } from "react-icons/vsc";
import { useAction } from "../useAction.js";

export const AiPromptBtn = ({setDescriptionText}) => {
  const {onClick: _onClick, loading} = useAction({playerAction: 'giveMyselfAiPrompt'})
  const onClick = () => {
    if (!confirm(`ai-generate an idea?`)) return
    _onClick?.()
  }

  return <PtBtn {...{isLoading: loading, onClick}}>
    <Icon {...{as: VscRobot}} />&nbsp;Idea
  </PtBtn>
}